import type { InsuranceFeatureConfig } from '../types/InsuranceFeatureConfig';
import { claimsConfig } from './configByFeature/claims';
import { dashboardConfig } from './configByFeature/dashboard';
import { fundsConfig } from './configByFeature/funds';
import { modificationsConfig } from './configByFeature/modifications';
import { servicingConfig } from './configByFeature/servicing';
import { belongingsConfig } from './configByInsuranceType/belongings';
import { carConfig } from './configByInsuranceType/car';
import { fundConfig } from './configByInsuranceType/fund';
import { liabilityConfig } from './configByInsuranceType/liability';
import { lifeConfig } from './configByInsuranceType/life';
import { productConfig } from './configByInsuranceType/product';
import { propertyConfig } from './configByInsuranceType/property';
import { travelConfig } from './configByInsuranceType/travel';

export const insurances: Partial<InsuranceFeatureConfig> = {
    defaultRoute: 'overview',
    showManageInsurance: false,
    relyOnWebAPIAlias: true,
    showCurrentCapitalValue: true,
    claims: claimsConfig.CZ,
    dashboard: dashboardConfig.CZ,
    funds: fundsConfig.CZ,
    modifications: modificationsConfig.CZ,
    servicing: servicingConfig.CZ,
    belongings: belongingsConfig.CZ,
    car: carConfig.CZ,
    fund: fundConfig.CZ,
    liability: liabilityConfig.CZ,
    life: lifeConfig.CZ,
    product: productConfig.CZ,
    property: propertyConfig.CZ,
    travel: travelConfig.CZ,
};
